import { FormattedMessage } from "react-intl";

import Nbsp from "@components/Nbsp";
import ExternalLink from "@components/typography/ExternalLink";
import { ResourceFragment } from "@typing/Generated";

type Props = {
  hotline: NonNullable<ResourceFragment["hotline"]>;
  journeyId: string;
  resource: ResourceFragment;
};

const HotlineLink = ({ hotline, journeyId, resource }: Props) => (
  <ExternalLink
    href={`tel:${hotline.phoneNumber}`}
    linkEventCreateVariables={{ journeyId, resourceId: resource.id, resourceType: resource.__typename }}
  >
    {hotline.phoneNumber}
    <Nbsp />
    <FormattedMessage id="dictionary.punctuation.dash" />
    <Nbsp />
    {hotline.name}
  </ExternalLink>
);

export default HotlineLink;
